import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { searchByPersonId } from "api";

export const fetchPersonById = createAsyncThunk(
	"person/fetchPersonById",
	async (personId, { rejectWithValue }) => {
		try {
			const data = await searchByPersonId({ personId });
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const PERSON_TEMPLATE = {
	id: null,
	userId: null,
	personId: null,
	firstName: null,
	lastName: null,
	fullName: null,
	preferredName: null,
	jobTitle: null,
	email: null,
	managerId: null,
	homeRc: null,
	employeeId: null,
	organisation: "WDHB",
	businessUnitId: null,
	isSystemAdmin: true,
	upn: null,
	companyId: 7,
};

const initialState = {
	status: "starting",
	error: null,
	data: {}, //target person of whatever form/data we're looking at
	cpeEnrolment: [],
	permission: [],
};

const personSlice = createSlice({
	name: "person",
	initialState,
	reducers: {
		personEdited(state, action) {
			state.data = action.payload;
		},
	},
	extraReducers: {
		[fetchPersonById.pending]: (state, action) => {
			state.status = "loading";
		},
		[fetchPersonById.fulfilled]: (state, action) => {
			state.status = "idle";
			state.data = action.payload; //set person data
		},
		[fetchPersonById.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
			state.data = {};
		},
	},
});

export const { personEdited } = personSlice.actions;

export const selectPerson = (state) => state.cme.person.data;
export const selectPersonCpeEnrolment = (state) =>
	state.cme.person.cpeEnrolment;
export const selectPersonStatus = (state) => state.cme.person.status;
export const selectPersonError = (state) => state.cme.person.error;

export default personSlice.reducer;
